import {ArchiveIcon, LockIcon, type OcticonProps, RepoForkedIcon, RepoIcon} from '@primer/octicons-react'

type RepositoryIconProps = Omit<OcticonProps, 'icon' | 'aria-label'> & {
  status: string
}

export function RepositoryIcon({status, ...props}: RepositoryIconProps) {
  switch (status) {
    case 'archived':
      return <ArchiveIcon aria-label="Archived repository" {...props} />
    case 'forked':
      return <RepoForkedIcon aria-label="Forked repository" {...props} />
    case 'public':
      return <RepoIcon aria-label="Public repository" {...props} />
    case 'private':
      return <LockIcon aria-label="Private repository" {...props} />
    default:
      return <RepoIcon aria-label="Repository" {...props} />
  }
}
